<template>
  <div>
    <slot
      :step="innerStep"
      :total="total"
      :next="next"
      :prev="prev"
      :reset="reset"
      :change="change"
    />
  </div>
</template>

<script>
import {
  getActiveStepComponent,
  getStepByComponent,
  registerStepComponent,
  getKeepState,
  getStep
} from './constant';

export default {
  name: 'BaseWizard',
  provide() {
    return {
      [getActiveStepComponent]: () => this.stepComponents[this.innerStep - 1],
      [registerStepComponent]: (component) => {
        this.stepComponents.push(component);
        return () => {
          this.stepComponents = this.stepComponents.filter((step) => step !== component);
        };
      },
      [getStepByComponent]: (component) => this.stepComponents.indexOf(component) + 1,
      [getKeepState]: () => this.keepState,
      [getStep]: () => this.innerStep
    };
  },
  props: {
    step: {
      type: Number,
      default: 1
    },
    keepState: Boolean
  },
  emits: ['change'],
  data() {
    return {
      innerStep: 1,
      stepComponents: []
    };
  },
  computed: {
    total() {
      return this.stepComponents.length;
    }
  },
  watch: {
    step: {
      immediate: true,
      handler(step) {
        this.innerStep = step;
      }
    }
  },
  methods: {
    reset() {
      this.handleChange(1);
    },
    change(step) {
      this.handleChange(this.prepareStep(step));
    },
    next() {
      this.handleChange(this.prepareStep(this.innerStep + 1));
    },
    prev() {
      this.handleChange(this.prepareStep(this.innerStep - 1));
    },
    handleChange(step) {
      this.innerStep = step;
      this.$emit('change', step);
    },
    prepareStep(step) {
      if (step < 1) {
        return 1;
      }
      if (step > this.total) {
        return this.total;
      }
      return step;
    }
  }
};
</script>

<i18n lang="json">{}</i18n>
